import throttle from './function/throttle.js'
import debounce from './function/debounce.js'
import timeFormat from './function/timeFormat.js'
import timeFrom from './function/timeFrom.js'
import deepClone from './function/deepClone.js'

/**
 * @description 倒计时计算
 * */
function downTime (time) {
  var days = parseInt(time / (1000 * 60 * 60 * 24))
  var hours = parseInt(time / (1000 * 60 * 60) % 24)
  var minutes = parseInt(time / (1000 * 60) % 60)
  var seconds = parseInt(time / 1000 % 60)
  return {
    days,
    hours: hours < 10 ? '0' + hours : hours,
    minutes: minutes < 10 ? '0' + minutes : minutes,
    seconds: seconds < 10 ? '0' + seconds : seconds
  }
}

/**
 * @description 参数序列化
 * */
function serialize (data) {
  let str = ''
  Object.keys(data).forEach(key => {
    str += key + '=' + data[key] + '&'
  })
  str = str.substr(0, str.length - 1)
  return str
}

/**
 * base64图片缓存到本地,返回本地路径
 * */
function base64ToPath (base64) {
  return new Promise(function (resolve, reject) {
    if (typeof window === 'object' && 'document' in window) {
      base64 = base64.split(',')
      var type = base64[0].match(/:(.*?);/)[1]
      var str = atob(base64[1])
      var n = str.length
      var array = new Uint8Array(n)
      while (n--) {
        array[n] = str.charCodeAt(n)
      }
      return resolve((window.URL || window.webkitURL).createObjectURL(new Blob([array], {
        type: type
      })))
    }
    var extName = base64.match(/data\:\S+\/(\S+);/)
    if (extName) {
      extName = extName[1]
    } else {
      reject(new Error('base64 error'))
    }
    var fileName = Date.now() + '.' + extName
    if (typeof plus === 'object') {
      var bitmap = new plus.nativeObj.Bitmap('bitmap' + Date.now())
      bitmap.loadBase64Data(base64, function () {
        var filePath = '_doc/uniapp_temp/' + fileName
        bitmap.save(filePath, {}, function () {
          bitmap.clear()
          resolve(filePath)
        }, function (error) {
          bitmap.clear()
          reject(error)
        })
      }, function (error) {
        bitmap.clear()
        reject(error)
      })
      return
    }
    if (typeof wx === 'object' && wx.canIUse('getFileSystemManager')) {
      var filePath = wx.env.USER_DATA_PATH + '/' + fileName
      wx.getFileSystemManager().writeFile({
        filePath: filePath,
        data: base64.replace(/^data:\S+\/\S+;base64,/, ''),
        encoding: 'base64',
        success: function () {
          resolve(filePath)
        },
        fail: function (error) {
          reject(error)
        }
      })
      return
    }
    reject(new Error('not support'))
  })
}

export default {
  serialize,
  debounce,
  throttle,
  timeFormat,
  timeFrom,
  deepClone,
  downTime,
  base64ToPath
}
